import * as Utils_String from "VSS/Utils/String";
import * as ProcessHttpClient from  "TFS/WorkItemTracking/ProcessRestClient";
import * as Service from "VSS/Service";

export namespace Utils {
    export function isStringNullOrEmpty(value: string): boolean {
        return value == null || value === Utils_String.empty;
    }

    // This method is inorder to use  WorkItemTrackingProcessHttpClient5 and the newly introduced process picklist api of version 5.0-preview.1 
    // Currently the the default workitemtrackingprocesshttpclient is version 4_1 as it is the released version.
    // Note that processrestclient.ts generated by genclient, only has httpclient of released version which is 4.1 in this case.  
    // So this is workaround to use WorkItemTrackingProcessHttpclient5. 
    export function getProcessClient(): ProcessHttpClient.WorkItemTrackingProcessHttpClient5 {
        return Service.getClient<ProcessHttpClient.WorkItemTrackingProcessHttpClient5>(ProcessHttpClient.WorkItemTrackingProcessHttpClient5);
    }
}
